import about from './about.json'
import authentication from './authentication.json'
import b2b from './b2b.json'
import bookings from './bookings.json'
import common from './common.json'
import errors from './errors.json'
import faq from './faq.json'
import favorites from './favorites.json'
import footer from './footer.json'
import golf from './golf.json'
import home from './home.json'
import navigation from './navigation.json'
import products from './products.json'
import profile from './profile.json'
import reservations from './reservations.json'
import search from './search.json'
import shopping from './shopping.json'
import validation from './validation.json'

export default {
  authentication,
  navigation,
  favorites,
  reservations,
  validation,
  search,
  footer,
  products,
  home,
  common,
  profile,
  b2b,
  about,
  faq,
  golf,
  errors,
  shopping,
  bookings,
}
